import styled from 'styled-components';
import LogoImage from '../../assets/images/logo.png';
import { Text } from '../../components/Text';

/* ── Layout ── */
export const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.background};
`;

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 0 2rem;
  background-color: ${(props) => props.theme.colors.background};
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  box-shadow: ${(props) => props.theme.shadows.sm};

  @media (max-width: 600px) {
    padding: 0 1rem;
  }
`;

export const HeaderMeta = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.textMuted};
`;

export const Logo = styled.img.attrs({
  src: LogoImage,
  alt: 'Meta Globaltech',
})`
  height: 36px;
  width: auto;
  object-fit: contain;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 2.5rem 1.5rem;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem;
  }
`;

/* ── Cards ── */
export const ProductDetailsContainer = styled.div`
  width: 100%;
  max-width: 680px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadiusMd};
  box-shadow: ${(props) => props.theme.shadows.sm};
  animation: fadeInUp 0.35s ease both;
`;

export const CompanyNameTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.title};
  line-height: 1.3;
`;

export const CnpjPTag = styled(Text)`
  font-size: 13px;
  color: ${(props) => props.theme.colors.textMuted};
  font-weight: 500;
`;

export const CompanyDescription = styled(Text)`
  font-size: 14px;
  line-height: 1.65;
  color: ${(props) => props.theme.colors.text};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 0.5rem;
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin-top: 0.5rem;

  > div {
    min-width: 120px;
  }
`;

/* ── Mensagem de sucesso ── */
export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem;
  text-align: center;

  svg {
    color: ${(props) => props.theme.colors.success};
    font-size: 40px;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.success};
  }

  p {
    font-size: 14px;
    color: ${(props) => props.theme.colors.textMuted};
  }
`;
